import { render, staticRenderFns } from "./ContentPicker.vue?vue&type=template&id=c0aa7b6a&lang=pug"
import script from "./ContentPicker.vue?vue&type=script&lang=js"
export * from "./ContentPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports